var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-8.079 -8.079 30 30",
    enableBackground: "new -8.079 -8.079 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-filter",
    fill: "#FF4700",
    d: "M16.172-3.29H-2.332c-0.529,0-0.958,0.428-0.958,0.957 c0,0.254,0.101,0.498,0.28,0.677l7.376,7.377v8.22c0,0.313,0.153,0.605,0.409,0.786l3.19,2.231c0.436,0.304,1.032,0.197,1.334-0.235 c0.112-0.161,0.173-0.354,0.173-0.55V5.723l7.377-7.376c0.374-0.373,0.377-0.979,0.003-1.354C16.674-3.189,16.429-3.291,16.172-3.29 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOrange);
export default __webpack_public_path__ + "static/media/filter-orange.12bb2f00378fd722779d3f8bf9134cd3.svg";
export { ForwardRef as ReactComponent };